module.exports = __webpack_public_path__ + "img/art_yumemaru.e0509897.png";